import { RefObject, useState } from 'react';
import useResizeObserver, { ObservedSize } from 'use-resize-observer';
import { useThrottle } from '@src/hooks/useThrottle';
import { AnyType } from '@src/models/common';

/** Используется для автоматического замера размеров элемента, при изменении размеров контейнера, который передается через ref.
 * Нужно использовать когда нужно проводить расчеты которые зависят от размеров DOM элемента.
 * */
export const useThrottledSize = ({ delay, ref }: { delay: number; ref: RefObject<AnyType> }) => {
  const [size, setSize] = useState<ObservedSize | object>({});
  const onResize = useThrottle(setSize, delay);

  useResizeObserver({ onResize, ref });

  return { ...size };
};
